import { render, staticRenderFns } from "./associaStatiPolizza.vue?vue&type=template&id=b3d96b98&"
import script from "./associaStatiPolizza.vue.ts?vue&type=script&lang=ts&"
export * from "./associaStatiPolizza.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports